import { createActionsGroup } from 'utils/redux-utils'

export const getDeliveryDatesByProducts = createActionsGroup(
  'GET_DELIVERY_DATES_BY_PRODUCTS',
)

export const getAllDeliveryDates = createActionsGroup('GET_ALL_DELIVERY_DATES')

export const getUserDeliveries = createActionsGroup('GET_USER_DELIVERIES')
